
import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class PageToolbar extends Vue {
  @Prop(String) readonly heading: string | undefined;
  @Prop([Number, String]) readonly total!: number | undefined;
}
